import React from 'react'

function TitleLeft({title}) {
  return (
    <h2 className='title-h2-l hidden'>{title}</h2>
  )
}

export default TitleLeft